import { useState, useEffect } from "react";

export const useIsEmbeddedApp = (): boolean => {
    const [isEmbeddedApp, setIsEmbeddedApp] = useState<boolean>(false);

    useEffect(() => {
        setIsEmbeddedApp(window !== window.parent);
    }, []);

    return isEmbeddedApp;
};
